export const FOOTERBAR_SELECTORS = {
   CURSOR_POSITION_ELEMENT: '#cursorPosition',
   WORDS_COUNT_ELEMENT: '#wordsCount',
} as const;